export default [
    {
        path: '/',
        meta: {
            requiresAuth: true,
            role: 'public',
            layout: 'AdminLayout',
        },
        children: [
            {
                path: '/dashboard-tourist-arrival',
                name: 'dashboard-tourist-arrival',
                component: () => import('@/Pages/DashboardTouristArrival.vue'),
            },
            {
                path: '/dashboard-flight',
                name: 'dashboard-flight',
                component: () => import('@/Pages/DashboardFlight.vue'),
            },
        ]
    }

]
